// extracted by mini-css-extract-plugin
export default {"subheading_color":"style_subheading_color__4eEvA"};